/**
 * Pedido do usuário (10/09): "preciso de uma forma clara para o usuário saber que tem pendências
 * em um condomínio que não está filtrado no momento" — extraído de `ClientSelector.tsx` pra ser
 * testável isoladamente (mesmo padrão já usado nesta sessão pra outras funções puras extraídas de
 * componentes).
 */

/** Mapa esparso: só os condomínios com pelo menos 1 pendência aparecem como chave (mesmo formato
 * devolvido por GET /admin/notifications/badge-counts-by-client, já achatado pro total). */
export type PendingByClient = Record<string, number>;

/** `true` quando existe pendência em algum condomínio QUE NÃO SEJA o selecionado no momento — não
 * soma o total, só acusa "tem algo em outro lugar" (o detalhamento por condomínio fica no badge
 * de cada item dentro do dropdown, não no indicador do botão). */
export function hasPendingInOtherClients(
  pendingByClient: PendingByClient | undefined,
  selectedClientId: string
): boolean {
  if (!pendingByClient) return false;
  return Object.entries(pendingByClient).some(([clientId, count]) => clientId !== selectedClientId && count > 0);
}

/** Soma o total de pendências de todos os condomínios EXCETO o selecionado — usado pela linha
 * "pendências em outros condomínios" do sino (NotificationBell.tsx). Aceita o mapa completo
 * (clientId → contagens, com `total` já calculado) devolvido por
 * GET /admin/notifications/badge-counts-by-client, não o mapa achatado de `PendingByClient`. */
export function sumPendingInOtherClients(
  countsByClient: Record<string, { total: number }> | null | undefined,
  selectedClientId: string | undefined
): number {
  if (!countsByClient || !selectedClientId) return 0;
  return Object.entries(countsByClient)
    .filter(([clientId]) => clientId !== selectedClientId)
    .reduce((sum, [, counts]) => sum + counts.total, 0);
}
